import { Markdown } from '../../../Markdown';
import { sanitizeAssistantBody } from '../message-utils';

// Assistant message body. The message-level copy affordance now lives in the
// tool bar row (see MessageRow); code fences still self-card their own per-block
// COPY button via Markdown.
export function AssistantMarkdownContent({
  displayed,
  isCursorOn,
}: {
  displayed: string;
  isCursorOn: boolean;
}) {
  return (
    // Strip the platform's own leaked `<metadata>`/`<system>` framing (tags AND content) and any
    // `<voice>` transcript-wrapper tags the assistant echoes back in its prose — wire markup, never
    // meant to be read (a whole-message voice turn is handled earlier as a dimmed transcript).
    // Mirrors the native `ChatText.sanitizeAssistantMessage`. `isCursorOn` marks the live-streaming
    // render, where an unclosed trailing framing partial is also dropped.
    //
    // No streaming caret: the reply growing is the only "still writing" signal, as on iOS and Android.
    <Markdown variant="chat" chatLinks>
      {sanitizeAssistantBody(displayed, isCursorOn)}
    </Markdown>
  );
}
